import { apiClient } from 'lib/api';
import { useMutation } from '@tanstack/react-query';
import type { MutationConfig } from 'lib/react-query';
import { isAxiosError } from 'axios';
import type { EmergencyParams } from './types';
import type { Network } from 'types/shared';
import initApiNetwork from '../../../utils/initApiNetwork';

interface EmergencyError {
  message: string;
}

export const toggleEmergency = async (
  body: EmergencyParams,
  network: Network
): Promise<EmergencyParams | EmergencyError> => {
  const apiNetwork = initApiNetwork(network);
  const res = await apiClient.post<EmergencyParams>(`${apiNetwork}/emergency`, body);
  if (isAxiosError(res)) {
    const error = new Error('Emergency toggle');
    error.cause = res.response?.data;
    return Promise.reject(error);
  }
  return res.data;
};

interface UseToggleEmergencyOptions {
  network: Network;
  config?: MutationConfig<typeof toggleEmergency>;
}

export const useToggleEmergency = ({ network, config }: UseToggleEmergencyOptions) => {
  return useMutation({
    ...config,
    onSuccess: async (...args) => {
      if (config?.onSuccess) {
        await config.onSuccess(...args);
      }
    },
    onError: (...args) => {
      if (config?.onError) {
        config.onError(...args);
      }
    },
    mutationFn: (params) => toggleEmergency(params, network),
  });
};
